import { useState, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { socket } from "../service/socket";

import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import { ConnexionContext } from "../components/provider";
import { useTheme } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import { LinearProgress, Typography, TableRow, TableCell, Table, TableBody, TableHead, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, useMediaQuery, Box, Chip, IconButton } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import "../../src/styles/responsive.css";

import BG from "../components/Background";
import Top from "../components/Header";
import Btn from "../components/Btn";
import DynamicSkillSelector from "../components/DynamicSkillSelector";
import PageLoader from "../components/PageLoader";

// ── Composants extraits ─────────────────────────────────────────
import { GAUGE_FIELDS as _GAUGE_FIELDS, isKanzyChar as _isKanzyChar, isMobChar as _isMobChar, parseSessionToken, expandAnimalInstances } from "../components/jdrConstants";
import MjKanzyEntityCard      from "../components/MjKanzyEntityCard";
import MjPlayerCharacterCard  from "../components/MjPlayerCharacterCard";
import MjPlayerTableRow       from "../components/MjPlayerTableRow";
import MjInitiativeSidebar    from "../components/MjInitiativeSidebar";
import MjSuccessSidebar       from "../components/MjSuccessSidebar";
import MjAlertDialog          from "../components/MjAlertDialog";
import MjGaugeEditDialog      from "../components/MjGaugeEditDialog";
import MjMobGaugeSetupDialog  from "../components/MjMobGaugeSetupDialog";
import MjConfirmInactiveDialog from "../components/MjConfirmInactiveDialog";
import MjScenarioEndDialog    from "../components/MjScenarioEndDialog";
// ───────────────────────────────────────────────────────────────


// ── Kanzy / MOB / PNJ ──────────────────────────────────────────
const KANZY_ID = 8;
const isKanzyChar = (char) => Number(char?.users_ID) === KANZY_ID;
const isMobChar   = _isMobChar; // inclut les animaux

// Charge les personnages de la session ; un animal "12x3" est démultiplié en 3 exemplaires
const fetchSessionCharacters = (idArray) =>
  Promise.all(
    idArray.map((token) => {
      const { id, count } = parseSessionToken(token);
      return fetch(`/api/characters/getOneCharacterById/${id}`)
        .then((res) => res.json())
        .then((data) => (data?.data ? expandAnimalInstances(data.data, count) : []))
        .catch(() => []);
    }),
  ).then((lists) => lists.flat());

// Jauges pleines (exemplaires d'animaux : jauges locales, non persistées)
const fullGauges = (char) => ({
  currentManaAir: char.ManaAir_character,
  currentManaEau: char.ManaEau_character,
  currentManaTerre: char.ManaTerre_character,
  currentManaFeu: char.ManaFeu_character,
  currentManaVolonte: char.ManaVolonte_character,
  currentManaVital: char.ManaVital_character,
  currentStamina: char.Stamina_character,
});

const GAUGE_FIELDS = [
  { key: "currentStamina",     label: "Stamina",       maxKey: "Stamina_character",      color: "#4caf50" },
  { key: "currentManaVital",   label: "Mana Vital",    maxKey: "ManaVital_character",    color: "#f87171" },
  { key: "currentManaAir",     label: "Mana Air",      maxKey: "ManaAir_character",      color: "#14b8a6" },
  { key: "currentManaEau",     label: "Mana Eau",      maxKey: "ManaEau_character",      color: "#60a5fa" },
  { key: "currentManaTerre",   label: "Mana Terre",    maxKey: "ManaTerre_character",    color: "#fb923c" },
  { key: "currentManaFeu",     label: "Mana Feu",      maxKey: "ManaFeu_character",      color: "#fb7185" },
  { key: "currentManaVolonte", label: "Mana Volonté",  maxKey: "ManaVolonte_character",  color: "#a855f7" },
];

const CARAC_FIELDS = [
  { key: "Force_character",      label: "Force" },
  { key: "Dexte_character",      label: "Dextérité" },
  { key: "Resistance_character", label: "Résistance" },
  { key: "Resilience_character", label: "Résilience" },
  { key: "Intell_character",     label: "Intelligence" },
  { key: "Charisme_character",   label: "Charisme" },
  { key: "Chance_character",     label: "Chance" },
];
// ───────────────────────────────────────────────────────────────

function ConnectGameMJ() {
  const { ids } = useParams();
  const idArray = ids.split("&&");
  const theme = useTheme();
  const {
    state: currentUser,
    setState: setCurrentUser,
    loading,
  } = useContext(ConnexionContext);

  let navigate = useNavigate();

  console.log(currentUser?.users_ID);
  const [characters, setCharacters] = useState([]);
  console.log(characters);

  useEffect(() => {
    fetchSessionCharacters(idArray).then(setCharacters);
  }, [ids]);

  const [selectorVisibleFor, setSelectorVisibleFor] = useState(null); // contient l’ID du joueur sélectionné
  const [skillScores, setSkillScores] = useState({});

  const [allCompetences, setAllCompetences] = useState([]);

  const [selected, setSelected] = useState(() => new Set());
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");

  // ── Édition directe des jauges Kanzy par le MJ ──
  const [mjEditDialog, setMjEditDialog] = useState(null);
  // { charName, charId, field, label, current, max, sign }
  const [mjEditDelta, setMjEditDelta] = useState("");

  // ── Initiative / Combat ─────────────────────────────────────────
  const [initiativeOrder, setInitiativeOrder] = useState({});
  const [combatInactives, setCombatInactives] = useState(new Set());
  const [combatActive, setCombatActive] = useState(false);
  const [currentTurnIdx, setCurrentTurnIdx] = useState(0);
  const [mobKoGauge, setMobKoGauge] = useState({});
  const [mobDeathGauge, setMobDeathGauge] = useState({});
  const [mobGaugeSetup, setMobGaugeSetup] = useState([]);
  const [mobGaugeSetupOpen, setMobGaugeSetupOpen] = useState(false);
  const [confirmInactiveChars, setConfirmInactiveChars] = useState([]);
  const [confirmInactiveOpen, setConfirmInactiveOpen] = useState(false);
  // ── Suivi des réussites ─────────────────────────────────────────
  const [successLog, setSuccessLog] = useState({});       // { [charId]: { [fieldKey]: { r, c } } }
  const [successCharFocus, setSuccessCharFocus] = useState(null);
  const [successSearchTerm, setSuccessSearchTerm] = useState({}); // { [charId]: string }
  // ───────────────────────────────────────────────────────────────

  const toggleSelected = (id) => {
    setSelected((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const selectAll = () =>
    setSelected(new Set(characters.map((c) => c.ID_character)));
  const clearAll = () => setSelected(new Set());

  const openEndDialog = () => {
    const targets = selected.size > 0
      ? [...selected].filter((id) => !String(id).includes("-"))
      : characters.filter((c) => !c._isInstance).map((c) => c.ID_character);
    if (selected.size === 0) setSelected(new Set(targets));

    targets.forEach((id) => {
      const log = successLog[id] || {};
      const autoRows = Object.entries(log)
        .filter(([, counts]) => counts.r >= 3 || counts.c >= 1)
        .map(([fieldKey]) => ({ field: fieldKey, delta: 1 }));

      setRewardsByCharId((prev) => {
        // Ne pas écraser des données déjà saisies manuellement
        if (prev[id]?.some((r) => r.field)) return prev;
        return {
          ...prev,
          [id]: autoRows.length > 0 ? autoRows : [{ field: "", delta: 0 }],
        };
      });
    });

    setEndOpen(true);
  };

  const openAlertDialogFor = (targets) => {
    setSelected(new Set(targets));
    setAlertOpen(true);
  };

  const sendAlert = () => {
    const targets = [...selected];
    if (!targets.length || !alertText.trim()) return;

    socket.emit("mj:sendAlert", {
      targets,
      message: alertText,
      severity: alertSeverity,
    });

    setAlertText("");
    setAlertOpen(false);
  };

  useEffect(() => {
    fetch(`/api/competences/findAllComp`)
      .then((res) => res.json())
      .then(setAllCompetences)
      .catch(console.error);
  }, []);

  const handleFinalSelection = (charId, path) => {
    const selectedId = path.at(-1);
    const comp = allCompetences.find((c) => c.id === selectedId);
    console.log("Compétence sélectionnée :", comp);

    if (!comp?.code) return;

    const fieldName = `${comp.code}_character`;
    const char = characters.find((c) => c.ID_character === charId);
    if (!char) return;

    const valeur = char[fieldName] ?? "N/A";

    setSkillScores((prev) => ({
      ...prev,
      [charId]: { valeur, label: comp.nom },
    }));

    setSelectorVisibleFor(null); // ferme le sélecteur après sélection
    console.log("Champ utilisé :", fieldName, "| Valeur :", valeur);
  };

  const [gaugesByCharId, setGaugesByCharId] = useState({});
  const [draconiqueByCharId, setDraconiqueByCharId] = useState({});
  const [celesteByCharId, setCelesteByCharId] = useState({});
  const [celesteInputByCharId, setCelesteInputByCharId] = useState({});

  // snapshot persisté en base : { [charId]: { ...statsAvant } } ou null si aucun scénar en cours
  const [scenarioSnapshot, setScenarioSnapshot] = useState(null);

  useEffect(() => {
    if (!characters.length) return;

    let cancelled = false;

    async function loadAllGaugesOnce() {
      try {
        const results = await Promise.all(
          characters.map(async (char) => {
            if (char._isInstance) return [char.ID_character, null];
            const name = encodeURIComponent(char.Name_character);
            const res = await fetch(`/api/gauges/getOneGauges/${name}`);
            const json = await res.json().catch(() => null);

            if (!res.ok || !json?.data) {
              return [
                char.ID_character,
                {
                  currentManaAir: char.ManaAir_character,
                  currentManaEau: char.ManaEau_character,
                  currentManaTerre: char.ManaTerre_character,
                  currentManaFeu: char.ManaFeu_character,
                  currentManaVolonte: char.ManaVolonte_character,
                  currentManaVital: char.ManaVital_character,
                  currentStamina: char.Stamina_character,
                },
              ];
            }

            return [char.ID_character, json.data];
          }),
        );

        if (cancelled) return;
        // Exemplaires d'animaux : on conserve leurs jauges locales (sinon pleines)
        setGaugesByCharId((prev) => Object.fromEntries(
          results.map(([id, data]) => {
            if (data) return [id, data];
            const char = characters.find((c) => c.ID_character === id);
            return [id, prev[id] ?? fullGauges(char)];
          }),
        ));

        // Charger les données draconiques pour les perso concernés
        const draconiqueChars = characters.filter(c => Number(c.HasDraconiqueHeart) > 0);
        if (draconiqueChars.length > 0) {
          const dracResults = await Promise.all(
            draconiqueChars.map(async (char) => {
              const name = encodeURIComponent(char.Name_character);
              const res = await fetch(`/api/draconiqueHeart/getOneDraconique/${name}`);
              const json = await res.json().catch(() => null);
              if (!res.ok || !json?.data) return [char.ID_character, null];
              return [char.ID_character, json.data];
            })
          );
          if (!cancelled) {
            setDraconiqueByCharId(Object.fromEntries(dracResults.filter(([, v]) => v !== null)));
          }
        }

        // Charger les données Céleste pour les perso concernés
        const celesteChars = characters.filter(c => Number(c.HasCeleste) === 1);
        if (celesteChars.length > 0) {
          const celesteResults = await Promise.all(
            celesteChars.map(async (char) => {
              const name = encodeURIComponent(char.Name_character);
              const res = await fetch(`/api/celesteConfig/getOne/${name}`);
              const json = await res.json().catch(() => null);
              if (!res.ok || !json?.data) return [char.ID_character, null];
              return [char.ID_character, json.data];
            })
          );
          if (!cancelled) {
            const celesteMap = Object.fromEntries(celesteResults.filter(([, v]) => v !== null));
            setCelesteByCharId(celesteMap);
            // Pré-remplir les inputs avec les valeurs existantes
            const inputs = {};
            for (const [id, data] of Object.entries(celesteMap)) {
              inputs[id] = { ...data };
            }
            setCelesteInputByCharId(inputs);
          }
        }
      } catch (e) {
        console.error("Erreur loadAllGauges:", e);
      }
    }

    loadAllGaugesOnce();


    return () => {
      cancelled = true;
    };
  }, [characters]);

  // Chargement des snapshots de début de scénario (persistés en base)
  useEffect(() => {
    const realChars = characters.filter((c) => !c._isInstance);
    if (!realChars.length) return;
    const ids = realChars.map((c) => c.ID_character).join(",");
    fetch(`/api/scenario/snapshots?ids=${ids}`)
      .then((r) => r.json())
      .then((json) => {
        if (json?.ok && Object.keys(json.data).length) {
          setScenarioSnapshot(json.data);
        }
      })
      .catch(console.error);
  }, [characters]);

  useEffect(() => {
    // ✅ écoute streaming (1 seule fois tant que characters est stable)
    const onGaugeUpdate = ({ name, patch }) => {
      console.log("MJ RECEIVED UPDATE", name, patch);

      if (!name || !patch) return;

      const char = characters.find(
        (c) => c.Name_character === name
      );

      if (!char) {
        console.log("No character found for", name);
        return;
      }

      const id = char.ID_character;

      setGaugesByCharId((prev) => ({
        ...prev,
        [id]: { ...(prev[id] || {}), ...patch },
      }));
    };


    socket.on("gauges:update", onGaugeUpdate);

    return () => {
      socket.off("gauges:update", onGaugeUpdate);
    };
  }, [characters]);

  useEffect(() => {
    console.log("MJ socket before");

    const joinRoom = () => {
      console.log("MJ socket connected");
      socket.emit("join:mj");
    };

    if (socket.connected) {
      // Cas 1 : déjà connecté
      joinRoom();
    } else {
      // Cas 2 : pas encore connecté
      socket.on("connect", joinRoom);
    }

    return () => {
      socket.off("connect", joinRoom);
    };
  }, []);



  // { [charId]: { ManaAirDraconiqueMax: 0, ... } } — valeurs initiales pour création cœur draconique
  const [draconiqueInitByCharId, setDraconiqueInitByCharId] = useState({});

  const updateDraconiqueInit = (charId, field, value) => {
    setDraconiqueInitByCharId(prev => ({
      ...prev,
      [charId]: { ...(prev[charId] || {}), [field]: value },
    }));
  };

  const updateCelesteInput = (charId, field, value) => {
    setCelesteInputByCharId(prev => ({
      ...prev,
      [charId]: { ...(prev[charId] || {}), [field]: value },
    }));
  };

  const BASE_STAT_OPTIONS = [
    { label: "Cœur Draconique (débloquer)", field: "HasDraconiqueHeart" },
    { label: "Céleste (débloquer)", field: "HasCeleste" },
    { label: "Force", field: "Force_character" },
    { label: "Dextérité", field: "Dexte_character" },
    { label: "Résistance", field: "Resistance_character" },
    { label: "Résilience", field: "Resilience_character" },
    { label: "Intelligence", field: "Intell_character" },
    { label: "Charisme", field: "Charisme_character" },
    { label: "Chance", field: "Chance_character" },

    { label: "Mana Vital (max)", field: "ManaVital_character" },
    { label: "Mana Air (max)", field: "ManaAir_character" },
    { label: "Mana Eau (max)", field: "ManaEau_character" },
    { label: "Mana Terre (max)", field: "ManaTerre_character" },
    { label: "Mana Feu (max)", field: "ManaFeu_character" },
    { label: "Mana Volonté (max)", field: "ManaVolonte_character" },
    { label: "Stamina (max)", field: "Stamina_character" },
  ];

  const COMP_OPTIONS = (allCompetences || [])
    .filter((c) => !!c.code)
    .map((c) => ({
      label: c.nom,
      field: `${c.code}_character`,
    }));

  const STAT_OPTIONS = [...BASE_STAT_OPTIONS, ...COMP_OPTIONS];

  const isMobile = useMediaQuery("(max-width: 768px)");

  const [endOpen, setEndOpen] = useState(false);

  // { [charId]: [{ field: string, delta: number }, ...] }
  const [rewardsByCharId, setRewardsByCharId] = useState({});

  const ensureRewardRows = (charId) => {
    setRewardsByCharId((prev) => {
      if (prev[charId]?.length) return prev;
      return { ...prev, [charId]: [{ field: "", delta: 0 }] };
    });
  };

  const addRewardRow = (charId) => {
    setRewardsByCharId((prev) => ({
      ...prev,
      [charId]: [...(prev[charId] || [{ field: "", delta: 0 }]), { field: "", delta: 0 }],
    }));
  };

  const removeRewardRow = (charId, idx) => {
    setRewardsByCharId((prev) => ({
      ...prev,
      [charId]: (prev[charId] || []).filter((_, i) => i !== idx),
    }));
  };

  const updateRewardRow = (charId, idx, patch) => {
    setRewardsByCharId((prev) => ({
      ...prev,
      [charId]: (prev[charId] || []).map((row, i) => (i === idx ? { ...row, ...patch } : row)),
    }));
  };

  const buildFieldLabel = (field) => {
    const found = STAT_OPTIONS.find((o) => o.field === field);
    return found?.label || field;
  };

  const handleStartScenario = async () => {
    const realChars = characters.filter((c) => !c._isInstance);
    const targets = realChars.map((c) => c.ID_character);
    const res = await fetch("/api/scenario/start", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ targets }),
    });
    const json = await res.json().catch(() => null);
    if (res.ok && json?.ok) {
      // Construire le snapshot local depuis les données déjà chargées
      const snapshot = {};
      for (const char of realChars) {
        snapshot[char.ID_character] = { ...char };
      }
      setScenarioSnapshot(snapshot);
    }
  };

  const handleEndScenario = async () => {
    const targets = [...selected].map(Number).filter(Boolean);
    if (!targets.length) return;

    // Identifier en avance les perso avec draconique sélectionné (avant filtrage delta)
    const draconiqueTargets = targets.filter(id =>
      (rewardsByCharId[id] || []).some(r => r.field === "HasDraconiqueHeart")
    );

    // Nettoyage du payload :
    // - on enlève les lignes vides / delta 0
    // - HasDraconiqueHeart : on ne l'envoie à l'API que si le perso ne l'a pas encore (évite d'incrémenter)
    const rewardsByChar = {};
    for (const id of targets) {
      const char = characters.find(c => c.ID_character === id);
      const rows = rewardsByCharId[id] || [];
      rewardsByChar[id] = rows
        .filter((r) => {
          if (!r?.field || !Number(r.delta)) return false;
          if (r.field === "HasDraconiqueHeart" && Number(char?.HasDraconiqueHeart) > 0) return false;
          return true;
        })
        .map((r) => ({ field: r.field, delta: Number(r.delta) }));
    }

    const hasAny = Object.values(rewardsByChar).some((arr) => arr.length);
    if (hasAny) {
      const res = await fetch("/api/scenario/end", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ targets, rewardsByChar }),
      });
      const json = await res.json().catch(() => null);
      if (!res.ok) {
        console.error("end scenario error:", json);
        return;
      }
    }

    // Créer ou mettre à jour les enregistrements draconiqueHeart
    // (indépendant du scenarioEnd : fonctionne même si HasDraconiqueHeart était déjà à 1)
    const draconiqueOps = draconiqueTargets.map(async (id) => {
      const char = characters.find(c => c.ID_character === id);
      if (!char) return;
      const init = draconiqueInitByCharId[id] || {};
      const airMax   = Number(init.ManaAirDraconiqueMax   || 0);
      const eauMax   = Number(init.ManaEauDraconiqueMax   || 0);
      const feuMax   = Number(init.ManaFeuDraconiqueMax   || 0);
      const terreMax = Number(init.ManaTerreDraconiqueMax || 0);
      const body = {
        ManaAirDraconiqueMax:       airMax,
        ManaEauDraconiqueMax:       eauMax,
        ManaFeuDraconiqueMax:       feuMax,
        ManaTerreDraconiqueMax:     terreMax,
        CurrentManaAirDraconique:   Number(init.CurrentManaAirDraconique   ?? airMax),
        CurrentManaEauDraconique:   Number(init.CurrentManaEauDraconique   ?? eauMax),
        CurrentManaFeuDraconique:   Number(init.CurrentManaFeuDraconique   ?? feuMax),
        CurrentManaTerreDraconique: Number(init.CurrentManaTerreDraconique ?? terreMax),
      };
      if (draconiqueByCharId[id]) {
        await fetch(`/api/draconiqueHeart/updateDraconique/${encodeURIComponent(char.Name_character)}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        }).catch(e => console.error("Erreur mise à jour cœur draconique :", e));
      } else {
        await fetch("/api/draconiqueHeart/createDraconiqueHeart", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Name_character: char.Name_character, ...body }),
        }).catch(e => console.error("Erreur création cœur draconique :", e));
      }
    });
    await Promise.all(draconiqueOps);

    // Céleste : créer (nouveau déblocage) ou mettre à jour (déjà actif)
    const CELESTE_FIELDS_KEYS = ["CelesteManaAir", "CelesteManaEau", "CelesteManaTerre", "CelesteManafeu", "CelesteManaVolonte", "CelesteManaVital"];
    const celesteOps = targets.map(async (id) => {
      const char = characters.find(c => c.ID_character === id);
      if (!char) return;
      const rows = rewardsByChar[id] || [];
      const isNewUnlock = rows.some(r => r.field === "HasCeleste" && Number(r.delta) > 0) && Number(char.HasCeleste) !== 1;
      const isExisting  = Number(char.HasCeleste) === 1;
      if (!isNewUnlock && !isExisting) return;

      const inputs = celesteInputByCharId[id] || {};
      const hasInput = CELESTE_FIELDS_KEYS.some(f => inputs[f] !== undefined && inputs[f] !== "");
      if (!hasInput) return;

      const payload = { Name_character: char.Name_character };
      for (const f of CELESTE_FIELDS_KEYS) {
        if (inputs[f] !== undefined && inputs[f] !== "") payload[f] = Number(inputs[f]);
        else if (isNewUnlock) payload[f] = 0;
      }

      if (isNewUnlock) {
        await fetch("/api/celesteConfig/create", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }).catch(e => console.error("Erreur création céleste :", e));
      } else {
        await fetch(`/api/celesteConfig/update/${encodeURIComponent(char.Name_character)}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }).catch(e => console.error("Erreur mise à jour céleste :", e));
      }
    });
    await Promise.all(celesteOps);

    // Construire summaryByTarget pour le socket (pop-up joueur)
    // On se base sur ce que tu as envoyé (rewardsByChar),
    // pas besoin d'attendre le result pour ça.
    const summaryByTarget = {};
    for (const id of targets) {
      const rows = rewardsByChar[id] || [];
      summaryByTarget[id] = {
        title: "Fin de scénario",
        lines: rows.map((r) => `+${r.delta} ${buildFieldLabel(r.field)}`),
      };
    }

    socket.emit("mj:scenarioEnd", { targets, summaryByTarget });

    setEndOpen(false);
    setScenarioSnapshot((prev) => {
      if (!prev) return null;
      const next = { ...prev };
      for (const id of targets) delete next[id];
      return Object.keys(next).length ? next : null;
    });

    // Rafraîchir les personnages pour que le MJ voie les nouvelles valeurs (HasDraconiqueHeart, HasCeleste, stats…)
    const freshChars = await fetchSessionCharacters(idArray);
    setCharacters(freshChars);

    // Re-charger draconique et céleste pour les persos nouvellement débloqués
    const newDracChars = freshChars.filter(c => Number(c.HasDraconiqueHeart) > 0);
    if (newDracChars.length) {
      const dracResults = await Promise.all(
        newDracChars.map(async (char) => {
          const name = encodeURIComponent(char.Name_character);
          const res = await fetch(`/api/draconiqueHeart/getOneDraconique/${name}`);
          const json = await res.json().catch(() => null);
          if (!res.ok || !json?.data) return [char.ID_character, null];
          return [char.ID_character, json.data];
        })
      );
      setDraconiqueByCharId(Object.fromEntries(dracResults.filter(([, v]) => v !== null)));
    }

    const newCelesteChars = freshChars.filter(c => Number(c.HasCeleste) === 1);
    if (newCelesteChars.length) {
      const celesteResults = await Promise.all(
        newCelesteChars.map(async (char) => {
          const name = encodeURIComponent(char.Name_character);
          const res = await fetch(`/api/celesteConfig/getOne/${name}`);
          const json = await res.json().catch(() => null);
          if (!res.ok || !json?.data) return [char.ID_character, null];
          return [char.ID_character, json.data];
        })
      );
      const celesteMap = Object.fromEntries(celesteResults.filter(([, v]) => v !== null));
      setCelesteByCharId(celesteMap);
      setCelesteInputByCharId(prev => {
        const next = { ...prev };
        for (const [id, data] of Object.entries(celesteMap)) next[id] = { ...data };
        return next;
      });
    }
  };

  // ── Handlers édition jauges Kanzy ──────────────────────────────
  const openMJEdit = (char, gaugeField, sign) => {
    const gauges = gaugesByCharId[char.ID_character] || {};
    const current = Number(gauges[gaugeField.key] ?? char[gaugeField.maxKey]);
    const max = Number(char[gaugeField.maxKey]);
    setMjEditDelta("");
    setMjEditDialog({
      charName: char.Name_character,
      charId:   char.ID_character,
      isInstance: !!char._isInstance,
      field:    gaugeField.key,
      label:    gaugeField.label,
      current,
      max,
      sign,
    });
  };

  const confirmMJEdit = async () => {
    if (!mjEditDialog || mjEditDelta === "") return;
    const { charName, charId, isInstance, field, current, max, sign } = mjEditDialog;
    const newValue = Math.max(0, Math.min(max, current + Math.abs(Number(mjEditDelta)) * sign));
    // Exemplaire d'animal : jauge purement locale
    if (isInstance) {
      setGaugesByCharId((prev) => ({
        ...prev,
        [charId]: { ...(prev[charId] || {}), [field]: newValue },
      }));
      setMjEditDialog(null);
      return;
    }
    try {
      const res = await fetch(`/api/gauges/updateGauges/${encodeURIComponent(charName)}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ [field]: newValue }),
      });
      if (res.ok) {
        setGaugesByCharId((prev) => ({
          ...prev,
          [charId]: { ...(prev[charId] || {}), [field]: newValue },
        }));
      }
    } catch (e) {
      console.error("MJ gauge update error:", e);
    }
    setMjEditDialog(null);
  };
  // ───────────────────────────────────────────────────────────────

  // ── KO / Mort ───────────────────────────────────────────────────
  const isKO = (char) => {
    const gauges = gaugesByCharId[char.ID_character] || {};
    if (isMobChar(char)) {
      const koKey = mobKoGauge[char.ID_character];
      if (!koKey) return false;
      const gf = GAUGE_FIELDS.find((f) => f.key === koKey);
      return Number(gauges[koKey] ?? char[gf?.maxKey]) === 0;
    }
    return Number(gauges.currentStamina ?? char.Stamina_character) === 0;
  };

  const isDead = (char) => {
    const gauges = gaugesByCharId[char.ID_character] || {};
    if (isMobChar(char)) {
      const deathKey = mobDeathGauge[char.ID_character];
      if (!deathKey) return false;
      const gf = GAUGE_FIELDS.find((f) => f.key === deathKey);
      return Number(gauges[deathKey] ?? char[gf?.maxKey]) === 0;
    }
    return Number(gauges.currentManaVital ?? char.ManaVital_character) === 0;
  };

  // ── Cycle d'initiative ──────────────────────────────────────────
  const getActiveTurnOrder = () =>
    characters
      .filter((c) => !combatInactives.has(c.ID_character) && initiativeOrder[c.ID_character])
      .sort((a, b) => Number(initiativeOrder[a.ID_character]) - Number(initiativeOrder[b.ID_character]));

  const handleStartCombat = () => {
    const activeChars = characters.filter((c) => !combatInactives.has(c.ID_character));
    const missingInit = activeChars.filter((c) => !initiativeOrder[c.ID_character]);
    if (missingInit.length > 0) {
      setConfirmInactiveChars(missingInit);
      setConfirmInactiveOpen(true);
      return;
    }
    const needSetup = activeChars
      .filter(isMobChar)
      .filter((c) => !mobKoGauge[c.ID_character] || !mobDeathGauge[c.ID_character]);
    if (needSetup.length > 0) {
      setMobGaugeSetup(needSetup.map((c) => ({
        charId: c.ID_character, charName: c.Name_character,
        ko: mobKoGauge[c.ID_character] || "", death: mobDeathGauge[c.ID_character] || "",
      })));
      setMobGaugeSetupOpen(true);
      return;
    }
    setCurrentTurnIdx(0);
    setCombatActive(true);
  };

  const handleNextTurn = () => {
    const order = getActiveTurnOrder();
    if (!order.length) return;
    let next = (currentTurnIdx + 1) % order.length;
    for (let i = 0; i < order.length; i++) {
      if (!isKO(order[next]) && !isDead(order[next])) break;
      next = (next + 1) % order.length;
    }
    setCurrentTurnIdx(next);
  };

  const handleEndCombat = () => { setCombatActive(false); setCurrentTurnIdx(0); };

  const logSuccess = (charId, fieldKey, isCritique) => {
    setSuccessLog((prev) => ({
      ...prev,
      [charId]: {
        ...prev[charId],
        [fieldKey]: {
          r: (prev[charId]?.[fieldKey]?.r || 0) + (isCritique ? 0 : 1),
          c: (prev[charId]?.[fieldKey]?.c || 0) + (isCritique ? 1 : 0),
        },
      },
    }));
  };
  const removeSuccess = (charId, fieldKey) => {
    setSuccessLog((prev) => {
      const updated = { ...prev[charId] };
      delete updated[fieldKey];
      return { ...prev, [charId]: updated };
    });
  };
  // ───────────────────────────────────────────────────────────────

  const isInvalidUser =
    !currentUser ||
    (Array.isArray(currentUser) && currentUser.length === 0) ||
    (typeof currentUser === "object" && Object.keys(currentUser).length === 0);

  if (!loading && isInvalidUser) {
    navigate("/", { replace: true });
    return null;
  }

  const getCharGauges = (char) => {
    const gauges = gaugesByCharId[char.ID_character];
    const n = (v) => Number(v);
    const clamp = (v) => Math.min(100, Math.max(0, v));
    const currentManaVital = n(gauges?.currentManaVital ?? char.ManaVital_character);
    const currentStamina = n(gauges?.currentStamina ?? char.Stamina_character);
    const currentManaAir = n(gauges?.currentManaAir ?? char.ManaAir_character);
    const currentManaEau = n(gauges?.currentManaEau ?? char.ManaEau_character);
    const currentManaTerre = n(gauges?.currentManaTerre ?? char.ManaTerre_character);
    const currentManaFeu = n(gauges?.currentManaFeu ?? char.ManaFeu_character);
    const currentManaVolonte = n(gauges?.currentManaVolonte ?? char.ManaVolonte_character);
    return {
      currentManaVital, currentStamina, currentManaAir, currentManaEau,
      currentManaTerre, currentManaFeu, currentManaVolonte,
      clampedManaVital: clamp((currentManaVital / char.ManaVital_character) * 100),
      clampedStamina: clamp((currentStamina / char.Stamina_character) * 100),
      clampedManaAir: clamp((currentManaAir / char.ManaAir_character) * 100),
      clampedManaEau: clamp((currentManaEau / char.ManaEau_character) * 100),
      clampedManaTerre: clamp((currentManaTerre / char.ManaTerre_character) * 100),
      clampedManaFeu: clamp((currentManaFeu / char.ManaFeu_character) * 100),
      clampedManaVolonte: clamp((currentManaVolonte / char.ManaVolonte_character) * 100),
    };
  };

  if (loading) return <PageLoader />;

  // Sépare les joueurs des entités Kanzy (MOB / PNJ)
  const kanzyChars  = characters.filter(isKanzyChar);
  const playerChars = characters.filter((c) => !isKanzyChar(c));
  const pnjChars    = kanzyChars.filter((c) => !isMobChar(c));

  const activeTurnOrder = getActiveTurnOrder();
  const currentTurnCharId = combatActive && activeTurnOrder.length > 0
    ? activeTurnOrder[currentTurnIdx % activeTurnOrder.length]?.ID_character
    : null;

  // Section "Entités en jeu" — ↓ ancienne version inline commentée, remplacée par MjKanzyEntityCard
  /* const kanzySection = kanzyChars.length > 0 && (
    <Box sx={{ mt: 3, pt: 2, borderTop: "1px dashed rgba(255,165,0,0.35)" }}>
      <Typography variant="h6" sx={{ color: "#ffa726", mb: 2, textAlign: "center" }}>
        ⚔️ Entités en jeu
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, justifyContent: "center" }}>
        {kanzyChars.map((char) => {
          const mob    = isMobChar(char);
          const gauges = gaugesByCharId[char.ID_character] || {};
          const activeGauges = GAUGE_FIELDS.filter((f) => Number(char[f.maxKey]) > 0);
          const activeCaracs = CARAC_FIELDS.filter((f) => Number(char[f.key])    > 0);

          return (
            <Box
              key={char.ID_character}
              sx={{
                border: currentTurnCharId === char.ID_character
                  ? "2px solid #ffa726"
                  : "1px solid rgba(255,165,0,0.4)",
                borderRadius: 2,
                p: 2,
                minWidth: 280,
                maxWidth: 380,
                flex: "1 1 280px",
                background: currentTurnCharId === char.ID_character
                  ? "rgba(255,167,38,0.12)"
                  : "rgba(255,100,0,0.05)",
                opacity: isKO(char) && !isDead(char) ? 0.4 : 1,
                position: "relative",
                transition: "border 0.3s, background 0.3s",
              }}
            >
              {isDead(char) && (
                <Box sx={{ position: "absolute", inset: 0, borderRadius: 2, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.78)", zIndex: 2, gap: 0.5, pointerEvents: "none" }}>
                  <Typography sx={{ fontSize: "2.5rem", lineHeight: 1 }}>💀</Typography>
                  <Typography sx={{ color: "#f87171", fontWeight: "bold", letterSpacing: "0.3em", fontSize: "1.2rem" }}>MORT</Typography>
                </Box>
              )}
              // En-tête
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                <Typography variant="h6" sx={{ color: "#ffa726", flex: 1 }}>
                  {char.Name_character}
                </Typography>
                <Chip
                  label={mob ? "MOB" : "PNJ"}
                  size="small"
                  sx={{ background: mob ? "#7f1d1d" : "#1e3a5f", color: "white", fontWeight: "bold" }}
                />
              </Box>

              // Caractéristiques
              {activeCaracs.length > 0 && (
                <>
                  <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.45)", display: "block", mb: 0.5, letterSpacing: 1 }}>
                    CARACTÉRISTIQUES
                  </Typography>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                    {activeCaracs.map((f) => (
                      <Box key={f.key} sx={{ textAlign: "center", minWidth: 56, background: "rgba(255,255,255,0.06)", borderRadius: 1, p: "4px 8px" }}>
                        <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.45)", display: "block" }}>
                          {f.label}
                        </Typography>
                        <Typography sx={{ color: "white", fontWeight: "bold", fontSize: "1rem" }}>
                          {char[f.key]}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </>
              )}

              // Jauges éditables
              {activeGauges.length > 0 && (
                <>
                  <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.45)", display: "block", mb: 1, letterSpacing: 1 }}>
                    JAUGES
                  </Typography>
                  {activeGauges.map((f) => {
                    const current = Number(gauges[f.key] ?? char[f.maxKey]);
                    const max     = Number(char[f.maxKey]);
                    const pct     = Math.min(100, Math.max(0, (current / max) * 100));
                    return (
                      <Box key={f.key} sx={{ mb: 1.5 }}>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.25 }}>
                          <Typography variant="caption" sx={{ color: f.color, fontWeight: "bold" }}>
                            {f.label}
                          </Typography>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
                            <IconButton size="small" onClick={() => openMJEdit(char, f, -1)} sx={{ color: "#f87171", p: "2px" }}>
                              <RemoveCircleOutlineIcon fontSize="small" />
                            </IconButton>
                            <Typography variant="body2" sx={{ color: "white", minWidth: 72, textAlign: "center", fontSize: "0.85rem" }}>
                              {current} / {max}
                            </Typography>
                            <IconButton size="small" onClick={() => openMJEdit(char, f, 1)} sx={{ color: "#4ade80", p: "2px" }}>
                              <AddCircleOutlineIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </Box>
                        <LinearProgress
                          variant="determinate"
                          value={pct}
                          sx={{
                            height: 6,
                            borderRadius: 3,
                            backgroundColor: "rgba(255,255,255,0.1)",
                            "& .MuiLinearProgress-bar": { backgroundColor: f.color },
                          }}
                        />
                      </Box>
                    );
                  })}
                </>
              )}

              // Compétences — PNJ uniquement
              {!mob && (
                <Box sx={{ mt: 1.5, borderTop: "1px solid rgba(255,255,255,0.1)", pt: 1 }}>
                  <Btn
                    onClick={() => setSelectorVisibleFor(
                      selectorVisibleFor === char.ID_character ? null : char.ID_character
                    )}
                    msg="Compétence"
                  />
                  {selectorVisibleFor === char.ID_character && (
                    <DynamicSkillSelector
                      onFinalSelect={(path) => handleFinalSelection(char.ID_character, path)}
                    />
                  )}
                  {skillScores[char.ID_character] && (
                    <Typography sx={{ mt: 1, fontSize: "1.05rem", color: "lightblue" }}>
                      {skillScores[char.ID_character].label} : {skillScores[char.ID_character].valeur}
                    </Typography>
                  )}
                </Box>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  ); */
  // ── Nouvelle version avec composant ────────────────────────────
  const kanzySection = kanzyChars.length > 0 && (
    <Box sx={{ mt: 3, pt: 2, borderTop: "1px dashed rgba(255,165,0,0.35)" }}>
      <Typography variant="h6" sx={{ color: "#ffa726", mb: 2, textAlign: "center" }}>⚔️ Entités en jeu</Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, justifyContent: "center" }}>
        {kanzyChars.map((char) => (
          <MjKanzyEntityCard
            key={char.ID_character}
            char={char}
            gauges={gaugesByCharId[char.ID_character] || {}}
            currentTurnCharId={currentTurnCharId}
            isKO={isKO} isDead={isDead}
            openMJEdit={openMJEdit}
            selectorVisibleFor={selectorVisibleFor}
            setSelectorVisibleFor={setSelectorVisibleFor}
            handleFinalSelection={handleFinalSelection}
            skillScores={skillScores}
          />
        ))}
      </Box>
    </Box>
  );

  const actionButtons = (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "center", marginBottom: 10 }}>
      <Btn msg="Tout sélectionner" onClick={selectAll} />
      <Btn msg="Vider sélection" onClick={clearAll} />
      <Btn msg="Alerte sélection" onClick={() => setAlertOpen(true)} />
      <Btn msg="Alerte à tous" onClick={() => openAlertDialogFor(characters.map((c) => c.ID_character))} />
    </div>
  );

  // ── Panneau réussites (droite) — ↓ inline commenté, remplacé par MjSuccessSidebar ──
  /* const successSidebar = (
    <Box sx={{ position: "fixed", right: 8, top: "72px", width: 220, maxHeight: "70vh", overflowY: "auto", background: "rgba(8,8,18,0.93)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 2, zIndex: 40, p: 1.5, display: "flex", flexDirection: "column", gap: 0.75 }}>
      <Typography variant="subtitle2" sx={{ color: "#a78bfa", textAlign: "center", fontWeight: "bold", borderBottom: "1px solid rgba(255,255,255,0.1)", pb: 0.75 }}>
        📋 Réussites
      </Typography>

      <TextField
        select size="small" label="Personnage"
        value={successCharFocus ?? ""}
        onChange={(e) => setSuccessCharFocus(Number(e.target.value))}
        SelectProps={{ MenuProps: { PaperProps: { sx: { maxHeight: 200 } } } }}
        sx={{ "& .MuiInputBase-input": { fontSize: "0.78rem", py: 0.5 } }}
      >
        {[...playerChars, ...pnjChars].map((c) => (
          <MenuItem key={c.ID_character} value={c.ID_character} sx={{ fontSize: "0.8rem" }}>
            {c.Name_character}
          </MenuItem>
        ))}
      </TextField>

      {successCharFocus != null && (() => {
        const log = successLog[successCharFocus] || {};
        const search = successSearchTerm[successCharFocus] || "";
        const matches = search.length >= 1
          ? STAT_OPTIONS.filter((o) => o.label.toLowerCase().includes(search.toLowerCase())).slice(0, 5)
          : [];
        return (
          <>
            <TextField
              size="small" placeholder="Rechercher une compétence..."
              value={search}
              onChange={(e) => setSuccessSearchTerm((prev) => ({ ...prev, [successCharFocus]: e.target.value }))}
              sx={{ "& .MuiInputBase-input": { fontSize: "0.75rem", py: 0.5 } }}
            />

            {matches.map((opt) => (
              <Box key={opt.field} sx={{ display: "flex", alignItems: "center", gap: 0.5, p: "2px 6px", background: "rgba(255,255,255,0.05)", borderRadius: 1 }}>
                <Typography sx={{ flex: 1, color: "rgba(255,255,255,0.8)", fontSize: "0.72rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {opt.label}
                </Typography>
                <Button size="small" sx={{ minWidth: 0, p: "1px 6px", fontSize: "0.65rem", color: "#90caf9" }}
                  onClick={() => { logSuccess(successCharFocus, opt.field, false); setSuccessSearchTerm((prev) => ({ ...prev, [successCharFocus]: "" })); }}>
                  R
                </Button>
                <Button size="small" sx={{ minWidth: 0, p: "1px 6px", fontSize: "0.65rem", color: "#fbbf24" }}
                  onClick={() => { logSuccess(successCharFocus, opt.field, true); setSuccessSearchTerm((prev) => ({ ...prev, [successCharFocus]: "" })); }}>
                  ★
                </Button>
              </Box>
            ))}

            {Object.entries(log).length > 0 && (
              <>
                <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.35)", mt: 0.25, display: "block" }}>
                  Enregistré :
                </Typography>
                {Object.entries(log).map(([fieldKey, counts]) => {
                  const flagged = counts.r >= 3 || counts.c >= 1;
                  return (
                    <Box key={fieldKey} sx={{ display: "flex", alignItems: "center", gap: 0.5, p: "2px 4px", borderRadius: 1, background: flagged ? "rgba(255,167,38,0.12)" : "rgba(255,255,255,0.04)", border: flagged ? "1px solid rgba(255,167,38,0.35)" : "1px solid transparent" }}>
                      <Typography sx={{ flex: 1, color: "white", fontSize: "0.7rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {buildFieldLabel(fieldKey)}
                      </Typography>
                      <Typography sx={{ color: "#90caf9", fontSize: "0.65rem" }}>{counts.r}R</Typography>
                      <Typography sx={{ color: "#fbbf24", fontSize: "0.65rem", ml: 0.25 }}>{counts.c}★</Typography>
                      {flagged && <Typography sx={{ fontSize: "0.7rem" }}>⬆</Typography>}
                      <IconButton size="small" sx={{ p: 0, color: "rgba(255,255,255,0.3)", ml: 0.25 }}
                        onClick={() => removeSuccess(successCharFocus, fieldKey)}>
                        <Typography sx={{ fontSize: "0.65rem", lineHeight: 1 }}>✕</Typography>
                      </IconButton>
                    </Box>
                  );
                })}
              </>
            )}
            {Object.entries(log).length === 0 && search.length === 0 && (
              <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.25)", textAlign: "center", display: "block" }}>
                Aucune réussite enregistrée
              </Typography>
            )}
          </>
        );
      })()}
    </Box>
  ); */
  const successSidebar = (
    <MjSuccessSidebar
      playerChars={playerChars} pnjChars={pnjChars}
      successCharFocus={successCharFocus} setSuccessCharFocus={setSuccessCharFocus}
      successSearchTerm={successSearchTerm} setSuccessSearchTerm={setSuccessSearchTerm}
      successLog={successLog} logSuccess={logSuccess} removeSuccess={removeSuccess}
      statOptions={COMP_OPTIONS}
    />
  );

  // ── Panneau initiative ──────────────────────────────────────────
  // ↓ inline commenté, remplacé par MjInitiativeSidebar
  /* const initiativeSidebar = (
    <Box sx={{ position: "fixed", left: "10vh", top: "20vw", width: 200, maxHeight: "70vh", overflowY: "auto", background: "rgba(8,8,18,0.93)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 2, zIndex: 40, p: 1.5, display: "flex", flexDirection: "column", gap: 0.75 }}>
      <Typography variant="subtitle1" sx={{ color: "#90caf9", textAlign: "center", fontWeight: "bold", mb: 0.5, borderBottom: "1px solid rgba(255,255,255,0.1)", pb: 0.75 }}>
        ⚔️ Initiative
      </Typography>

      {!combatActive && (
        <>
          <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.35)", textAlign: "center", display: "block", mb: 0.5 }}>
            Ordre · Actif/Inactif
          </Typography>
          {characters.map((char) => {
            const inactive = combatInactives.has(char.ID_character);
            return (
              <Box key={char.ID_character} sx={{ display: "flex", alignItems: "center", gap: 0.75, opacity: inactive ? 0.35 : 1 }}>
                <input
                  type="number" min="1" max={characters.length}
                  value={initiativeOrder[char.ID_character] || ""}
                  disabled={inactive}
                  onChange={(e) => setInitiativeOrder((prev) => ({ ...prev, [char.ID_character]: e.target.value }))}
                  style={{ width: 36, background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 4, color: "white", textAlign: "center", padding: "2px 4px", fontSize: "0.85rem" }}
                />
                <Typography variant="body2" sx={{ flex: 1, color: "white", fontSize: "0.78rem", lineHeight: 1.2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {char.Name_character}
                </Typography>
                <Chip
                  label={inactive ? "Off" : "On"}
                  size="small"
                  onClick={() => setCombatInactives((prev) => {
                    const next = new Set(prev);
                    next.has(char.ID_character) ? next.delete(char.ID_character) : next.add(char.ID_character);
                    return next;
                  })}
                  sx={{ cursor: "pointer", fontSize: "0.6rem", height: 16, px: 0.25, background: inactive ? "rgba(255,255,255,0.08)" : "rgba(76,175,80,0.25)", color: inactive ? "rgba(255,255,255,0.4)" : "#4caf50" }}
                />
              </Box>
            );
          })}
          <Button variant="contained" color="warning" size="small" onClick={handleStartCombat} sx={{ mt: 1.5 }} disabled={characters.length === 0}>
            ▶ Démarrer combat
          </Button>
        </>
      )}

      {combatActive && (
        <>
          <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.35)", textAlign: "center", display: "block", mb: 0.5 }}>
            Tour en cours
          </Typography>
          {activeTurnOrder.map((char, idx) => {
            const ko   = isKO(char);
            const dead = isDead(char);
            const isCurrent = idx === currentTurnIdx % activeTurnOrder.length;
            return (
              <Box key={char.ID_character} sx={{ display: "flex", alignItems: "center", gap: 0.75, p: "3px 6px", borderRadius: 1, border: isCurrent ? "1px solid #ffa726" : "1px solid transparent", background: isCurrent ? "rgba(255,167,38,0.15)" : "transparent", opacity: (ko || dead) ? 0.35 : 1 }}>
                <Typography sx={{ color: "#ffa726", fontWeight: "bold", minWidth: 16, fontSize: "0.78rem" }}>
                  {initiativeOrder[char.ID_character]}
                </Typography>
                <Typography sx={{ flex: 1, color: dead ? "#f87171" : "white", fontSize: "0.78rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", textDecoration: dead ? "line-through" : "none" }}>
                  {char.Name_character}
                </Typography>
                {dead && <Typography sx={{ color: "#f87171", fontSize: "0.6rem", fontWeight: "bold" }}>💀</Typography>}
                {ko && !dead && <Typography sx={{ color: "#fb923c", fontSize: "0.6rem", fontWeight: "bold" }}>KO</Typography>}
              </Box>
            );
          })}
          {characters.filter((c) => combatInactives.has(c.ID_character)).map((char) => (
            <Box key={char.ID_character} sx={{ display: "flex", alignItems: "center", gap: 0.75, p: "3px 6px", opacity: 0.25 }}>
              <Typography sx={{ color: "rgba(255,255,255,0.3)", minWidth: 16, fontSize: "0.78rem" }}>—</Typography>
              <Typography sx={{ flex: 1, color: "rgba(255,255,255,0.3)", fontSize: "0.78rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {char.Name_character}
              </Typography>
              <Typography sx={{ color: "rgba(255,255,255,0.3)", fontSize: "0.6rem" }}>inactif</Typography>
            </Box>
          ))}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, mt: 1.5 }}>
            <Button variant="contained" color="warning" size="small" onClick={handleNextTurn}>
              Suivant →
            </Button>
            <Button variant="outlined" color="error" size="small" onClick={handleEndCombat}>
              Fin de combat
            </Button>
          </Box>
        </>
      )}
    </Box>
  ); */
  const initiativeSidebar = (
    <MjInitiativeSidebar
      characters={characters} combatInactives={combatInactives} initiativeOrder={initiativeOrder}
      combatActive={combatActive} activeTurnOrder={activeTurnOrder} currentTurnIdx={currentTurnIdx}
      isKO={isKO} isDead={isDead}
      setCombatInactives={setCombatInactives} setInitiativeOrder={setInitiativeOrder}
      handleStartCombat={handleStartCombat} handleNextTurn={handleNextTurn} handleEndCombat={handleEndCombat}
    />
  );
  // ───────────────────────────────────────────────────────────────

  return (
    <div className="main">
      <BG />
      <Top started={currentUser} />
      {isMobile ? (
        <>
          <div style={{
            position: "fixed",
            top: "56px",
            left: 0,
            right: 0,
            zIndex: 50,
            background: "rgba(10,10,20,0.92)",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
            padding: "8px 12px",
            display: "flex",
            gap: 8,
            flexWrap: "wrap",
            justifyContent: "center",
            borderBottom: "1px solid rgba(255,255,255,0.1)",
          }}>
            <Btn msg="Tout sélectionner" onClick={selectAll} />
            <Btn msg="Vider sélection" onClick={clearAll} />
            <Btn msg="Alerte sélection" onClick={() => setAlertOpen(true)} />
            <Btn msg="Alerte à tous" onClick={() => openAlertDialogFor(characters.map((c) => c.ID_character))} />
          </div>
          <div style={{ padding: "130px 12px 100px", display: "flex", flexDirection: "column", gap: 16 }}>
          {/* ── Cartes joueurs mobile — remplacées par MjPlayerCharacterCard ── */}
          {playerChars.map((char) => (
            <MjPlayerCharacterCard
              key={char.ID_character}
              char={char}
              gauges={gaugesByCharId[char.ID_character]}
              draconique={draconiqueByCharId[char.ID_character] || null}
              celeste={celesteByCharId[char.ID_character] || null}
              isKO={isKO} isDead={isDead}
              selected={selected} toggleSelected={toggleSelected} currentTurnCharId={currentTurnCharId}
              selectorVisibleFor={selectorVisibleFor} setSelectorVisibleFor={setSelectorVisibleFor}
              handleFinalSelection={handleFinalSelection} skillScores={skillScores}
              openAlertDialogFor={openAlertDialogFor}
            />
          ))}
          {/* Entités Kanzy — mobile */}
          <Box sx={{ px: 1, pb: "100px" }}>{kanzySection}</Box>

          <Button
            variant="contained"
            color={scenarioSnapshot ? "success" : "primary"}
            onClick={handleStartScenario}
            disabled={!!scenarioSnapshot}
            sx={{ position: "fixed", left: 16, bottom: 16, zIndex: 9999 }}
          >
            {scenarioSnapshot ? "Scénario en cours" : "Début de scénario"}
          </Button>
          <Button variant="contained" onClick={openEndDialog} sx={{ position: "fixed", right: 16, bottom: 16, zIndex: 9999 }}>
            Fin de scénario
          </Button>
        </div>
        </>
      ) : (
        <div
          id="holocom"
          style={{
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            justifyContent: "space-around",
          }}
        >
        {initiativeSidebar}
        {successSidebar}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              position: "fixed",
              width: "70vw",
              alignSelf: "end",
              alignItems: "start",
              display: "flex",
              flexDirection: "column",
              textAlign: "right",
              justifyContent: "space-around",
            }}
          >
            <div
              style={{
                position: "fixed",
                display: "flex",
                flexDirection: "column",
                justifyContent: "inherit",
                bottom: "45vh",
                width: "auto",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  position: "fixed",
                  display: "flex",
                  left: "34vw",
                  top: "10vh",
                  flexDirection: "row",
                  justifyContent: "center",
                  width: "auto",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    position: "fixed",
                    display: "flex",
                    left: "22vw",
                    top: "15vh",
                    flexDirection: "column",
                    justifyContent: "center",
                    width: "auto",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      justifyContent: "center",
                      marginBottom: 10,
                    }}
                  >
                    <Btn msg="Tout sélectionner" onClick={selectAll} />
                    <Btn msg="Vider sélection" onClick={clearAll} />
                    <Btn
                      msg="Alerte sélection"
                      onClick={() => setAlertOpen(true)}
                    />
                    <Btn
                      msg="Alerte à tous"
                      onClick={() =>
                        openAlertDialogFor(
                          characters.map((c) => c.ID_character),
                        )
                      }
                    />
                  </div>

                  <Table sx={{ border: "none" }}>
                    <TableHead sx={{ border: "none" }}>
                      <TableRow variant="head" sx={{ border: "none" }}>
                        <TableCell sx={{ border: "none" }}></TableCell>
                        <TableCell sx={{ border: "none" }}>
                          {" "}
                          <Typography
                            className="label"
                            variant="h5"
                            sx={{ color: theme.custom.mymodal.text }}
                            s
                            textAlign={"center"}
                          >
                            Mana Vital
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ border: "none" }}>
                          <Typography
                            className="label"
                            variant="h5"
                            sx={{ color: theme.custom.mymodal.text }}
                            s
                            textAlign={"center"}
                          >
                            Stamina
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ border: "none" }}>
                          <Typography
                            className="label"
                            variant="h5"
                            sx={{ color: theme.custom.mymodal.text }}
                            s
                            textAlign={"center"}
                          >
                            Mana Air
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ border: "none" }}>
                          <Typography
                            className="label"
                            variant="h5"
                            sx={{ color: theme.custom.mymodal.text }}
                            s
                            textAlign={"center"}
                          >
                            Mana Eau
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ border: "none" }}>
                          <Typography
                            className="label"
                            variant="h5"
                            sx={{ color: theme.custom.mymodal.text }}
                            s
                            textAlign={"center"}
                          >
                            Mana Terre
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ border: "none" }}>
                          <Typography
                            className="label"
                            variant="h5"
                            sx={{ color: theme.custom.mymodal.text }}
                            s
                            textAlign={"center"}
                          >
                            Mana Feu
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ border: "none" }}>
                          <Typography
                            className="label"
                            variant="h5"
                            sx={{ color: theme.custom.mymodal.text }}
                            s
                            textAlign={"center"}
                          >
                            Mana Volonté
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ border: "none" }}>
                          <Typography
                            className="label"
                            variant="h5"
                            sx={{ color: theme.custom.mymodal.text }}
                            s
                            textAlign={"center"}
                          >
                            Compétence
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ border: "none" }}>
                          <Typography
                            className="label"
                            variant="h5"
                            sx={{ color: theme.custom.mymodal.text }}
                            textAlign="center"
                          >
                            Cœur ☽
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ border: "none" }}>
                          <Typography
                            className="label"
                            variant="h5"
                            sx={{ color: theme.custom.mymodal.text }}
                            textAlign="center"
                          >
                            Sélection
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ border: "none" }}>
                          <Typography
                            className="label"
                            variant="h5"
                            sx={{ color: theme.custom.mymodal.text }}
                            textAlign="center"
                          >
                            Alerte
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {playerChars.map((char) => (
                        <MjPlayerTableRow
                          key={char.ID_character}
                          char={char}
                          gauges={gaugesByCharId[char.ID_character]}
                          draconique={draconiqueByCharId[char.ID_character] || null}
                          celeste={celesteByCharId[char.ID_character] || null}
                          theme={theme}
                          isKO={isKO} isDead={isDead}
                          selected={selected} toggleSelected={toggleSelected} currentTurnCharId={currentTurnCharId}
                          selectorVisibleFor={selectorVisibleFor} setSelectorVisibleFor={setSelectorVisibleFor}
                          handleFinalSelection={handleFinalSelection} skillScores={skillScores}
                          openAlertDialogFor={openAlertDialogFor}
                        />
                      ))}
                      {false && playerChars.map((char) => {
                        // ancien code inline — conservé inactif, logique déplacée dans MjPlayerTableRow.jsx
                        const gauges = gaugesByCharId[char.ID_character];
                        // console.log("char:", char);
                        // 2) je crée des valeurs "courantes" avec fallback si pas encore chargé
                        const n = (v) => Number(v);
                        // utilitaire clamp identique à la page joueur
                        const currentManaVital = n(
                          gauges?.currentManaVital ?? char.ManaVital_character,
                        );
                        // console.log("currentManaVital: ", currentManaVital);
                        const currentStamina = n(
                          gauges?.currentStamina ?? char.Stamina_character,
                        );
                        // console.log("currentStamina: ", currentStamina);
                        const currentManaAir = n(
                          gauges?.currentManaAir ?? char.ManaAir_character,
                        );
                        // console.log("currentManaAir: ", currentManaAir);

                        const currentManaEau = n(
                          gauges?.currentManaEau ?? char.ManaEau_character,
                        );
                        // console.log("currentManaEau: ", currentManaEau);

                        const currentManaTerre = n(
                          gauges?.currentManaTerre ?? char.ManaTerre_character,
                        );
                        // console.log("currentManaTerre: ", currentManaTerre);

                        const currentManaFeu = n(
                          gauges?.currentManaFeu ?? char.ManaFeu_character,
                        );
                        // console.log("currentManaFeu: ", currentManaFeu);

                        const currentManaVolonte = n(
                          gauges?.currentManaVolonte ??
                          char.ManaVolonte_character,
                        );
                        // console.log("currentManaVolonte: ", currentManaVolonte);

                        const clamp = (v) => Math.min(100, Math.max(0, v));

                        // Mana Vital
                        const percentManaVital =
                          (currentManaVital / char.ManaVital_character) * 100;
                        // console.log("maxManaVital: ", char.ManaVital_character);
                        const clampedManaVital = clamp(percentManaVital);
                        // console.log("clampedManaVital: ", clampedManaVital);

                        // Stamina
                        const percentStamina =
                          (currentStamina / char.Stamina_character) * 100;
                        // console.log("maxStamina: ", char.Stamina_character);
                        const clampedStamina = clamp(percentStamina);
                        // console.log("clampedStamina: ", clampedStamina);

                        // Mana Air
                        const percentManaAir =
                          (currentManaAir / char.ManaAir_character) * 100;
                        // console.log("maxManaAir: ", char.ManaAir_character);
                        const clampedManaAir = clamp(percentManaAir);
                        // console.log("clampedManaAir: ", clampedManaAir);

                        // Mana Eau
                        const percentManaEau =
                          (currentManaEau / char.ManaEau_character) * 100;
                        // console.log("maxManaEau: ", char.ManaEau_character);
                        const clampedManaEau = clamp(percentManaEau);
                        // console.log("clampedManaEau: ", clampedManaEau);

                        // Mana Terre
                        const percentManaTerre =
                          (currentManaTerre / char.ManaTerre_character) * 100;
                        // console.log("maxManaTerre: ", char.ManaTerre_character);
                        const clampedManaTerre = clamp(percentManaTerre);
                        // console.log("clampedManaTerre: ", clampedManaTerre);

                        // Mana Feu
                        const percentManaFeu =
                          (currentManaFeu / char.ManaFeu_character) * 100;

                        // console.log("maxManaFeu: ", char.ManaFeu_character);
                        const clampedManaFeu = clamp(percentManaFeu);
                        // console.log("clampedManaFeu: ", clampedManaFeu);

                        // Mana Volonté
                        const percentManaVolonte =
                          (currentManaVolonte / char.ManaVolonte_character) *
                          100;
                        // console.log("maxManaVolonte: ",char.ManaVolonte_character);
                        const clampedManaVolonte = clamp(percentManaVolonte);
                        // console.log("clampedManaVolonte: ", clampedManaVolonte);

                        return (
                          <TableRow
                            key={char.ID_character}
                            sx={{
                              border: "none",
                              position: "relative",
                              opacity: isKO(char) && !isDead(char) ? 0.35 : 1,
                              outline: currentTurnCharId === char.ID_character ? "2px solid #ffa726" : "none",
                              background: currentTurnCharId === char.ID_character ? "rgba(255,167,38,0.1)" : "transparent",
                              transition: "background 0.3s",
                              ...(isDead(char) && {
                                "&::after": {
                                  content: '"💀  MORT"',
                                  position: "absolute",
                                  inset: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "rgba(0,0,0,0.72)",
                                  color: "#f87171",
                                  fontWeight: "bold",
                                  letterSpacing: "0.35em",
                                  fontSize: "1rem",
                                  zIndex: 2,
                                  pointerEvents: "none",
                                },
                              }),
                            }}
                          >
                            <TableCell sx={{ border: "none" }}>
                              {char.Name_character}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              <div
                                className="container"
                                style={{
                                  width: "120px",
                                  height: "60px",
                                  overflow: "hidden",
                                  margin: "0 auto",
                                }}
                              >
                                <CircularProgressbar
                                  value={clampedManaVital}
                                  circleRatio={0.5}
                                  styles={buildStyles({
                                    rotation: 0.75,
                                    strokeLinecap: "butt",
                                    pathTransitionDuration: 0.5,
                                    pathColor: `red`,
                                    textColor: "#f88",
                                    trailColor: "#af8c8d",
                                    backgroundColor: "#3e98c7",
                                  })}
                                />
                              </div>
                              <Typography
                                className="label"
                                variant="h5"
                                sx={{ color: theme.custom.mymodal.text }}
                                textAlign={"center"}
                              >
                                {currentManaVital} points
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              <div
                                className="container"
                                style={{
                                  width: "120px",
                                  height: "60px",
                                  overflow: "hidden",
                                  margin: "0 auto",
                                }}
                              >
                                <CircularProgressbar
                                  value={clampedStamina}
                                  circleRatio={0.5}
                                  styles={buildStyles({
                                    rotation: 0.75,
                                    strokeLinecap: "butt",
                                    pathTransitionDuration: 0.5,
                                    pathColor: "#4caf50",
                                    textColor: "#f88",
                                    trailColor: "#cfe9d2",
                                    backgroundColor: "#3e98c7",
                                  })}
                                />
                              </div>
                              <Typography
                                className="label"
                                variant="h5"
                                sx={{ color: theme.custom.mymodal.text }}
                                textAlign={"center"}
                              >
                                {currentStamina} points
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              <LinearProgress
                                color="success"
                                id="manaAir"
                                variant="determinate"
                                value={clampedManaAir}
                                sx={{
                                  height: "5px",
                                  width: "60px",
                                  borderRadius: "25px",
                                  transform: "rotate(-90deg)",
                                  "& .MuiLinearProgress-bar": { backgroundColor: "#14b8a6" },
                                }}
                              />
                              <Typography
                                className="label"
                                position={"relative"}
                                top={"5vh"}
                                variant="h5"
                                sx={{ color: theme.custom.mymodal.text }}
                                textAlign={"center"}
                              >
                                {currentManaAir} points
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              <LinearProgress
                                color="info"
                                id="manaEau"
                                variant="determinate"
                                value={clampedManaEau}
                                sx={{
                                  height: "5px",
                                  width: "60px",
                                  borderRadius: "25px",
                                  transform: "rotate(-90deg)",
                                }}
                              />
                              <Typography
                                className="label"
                                position={"relative"}
                                top={"5vh"}
                                variant="h5"
                                sx={{ color: theme.custom.mymodal.text }}
                                textAlign={"center"}
                              >
                                {currentManaEau} points
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              <LinearProgress
                                color="warning"
                                id="manaTerre"
                                variant="determinate"
                                value={clampedManaTerre}
                                sx={{
                                  height: "5px",
                                  width: "60px",
                                  borderRadius: "25px",
                                  transform: "rotate(-90deg)",
                                }}
                              />
                              <Typography
                                className="label"
                                position={"relative"}
                                top={"5vh"}
                                variant="h5"
                                sx={{ color: theme.custom.mymodal.text }}
                                textAlign={"center"}
                              >
                                {currentManaTerre} points
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              <LinearProgress
                                color="error"
                                id="manaFeu"
                                variant="determinate"
                                value={clampedManaFeu}
                                sx={{
                                  height: "5px",
                                  width: "60px",
                                  borderRadius: "25px",
                                  transform: "rotate(-90deg)",
                                  "& .MuiLinearProgress-bar": { backgroundColor: "#fb7185" },
                                  backgroundColor: "#991b1b",
                                }}
                              />
                              <Typography
                                className="label"
                                position={"relative"}
                                top={"5vh"}
                                variant="h5"
                                sx={{ color: theme.custom.mymodal.text }}
                                textAlign={"center"}
                              >
                                {currentManaFeu} points
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              <LinearProgress
                                color="primary"
                                id="manaVolonte"
                                variant="determinate"
                                value={clampedManaVolonte}
                                sx={{
                                  height: "5px",
                                  width: "60px",
                                  borderRadius: "25px",
                                  transform: "rotate(-90deg)",
                                  "& .MuiLinearProgress-bar": { backgroundColor: "#a855f7" },
                                  backgroundColor: "#6b21a8",
                                }}
                              />
                              <Typography
                                className="label"
                                position={"relative"}
                                top={"5vh"}
                                variant="h5"
                                sx={{ color: theme.custom.mymodal.text }}
                                textAlign={"center"}
                              >
                                {currentManaVolonte} points
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              <Btn
                                onClick={() =>
                                  setSelectorVisibleFor(
                                    selectorVisibleFor === char.ID_character
                                      ? null
                                      : char.ID_character,
                                  )
                                }
                                msg="Compétence"
                              />

                              {selectorVisibleFor === char.ID_character && (
                                <DynamicSkillSelector
                                  onFinalSelect={(path) =>
                                    handleFinalSelection(
                                      char.ID_character,
                                      path,
                                    )
                                  }
                                />
                              )}

                              {skillScores[char.ID_character] && (
                                <h2
                                  style={{
                                    marginTop: "8px",
                                    fontSize: "1.2rem",
                                    color: "white",
                                  }}
                                >
                                  {skillScores[char.ID_character].label} :{" "}
                                  {skillScores[char.ID_character].valeur}
                                </h2>
                              )}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              <input
                                type="checkbox"
                                checked={selected.has(char.ID_character)}
                                onChange={() =>
                                  toggleSelected(char.ID_character)
                                }
                              />
                            </TableCell>

                            <TableCell sx={{ border: "none" }}>
                              <Btn
                                msg="Envoyer"
                                onClick={() =>
                                  openAlertDialogFor([char.ID_character])
                                }
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      {/* fin ancien code inline */}
                    </TableBody>
                  </Table>

                  {/* Entités Kanzy — desktop */}
                  <Box sx={{ mt: 2, mb: "80px" }}>{kanzySection}</Box>

                  <Button
                    variant="contained"
                    color={scenarioSnapshot ? "success" : "primary"}
                    onClick={handleStartScenario}
                    disabled={!!scenarioSnapshot}
                    sx={{ position: "fixed", left: 16, bottom: 16, zIndex: 9999 }}
                  >
                    {scenarioSnapshot ? "Scénario en cours" : "Début de scénario"}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={openEndDialog}
                    sx={{ position: "fixed", right: 16, bottom: 16, zIndex: 9999 }}
                  >
                    Fin de scénario
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      )}

      <MjAlertDialog
        open={alertOpen} onClose={() => setAlertOpen(false)}
        alertText={alertText} setAlertText={setAlertText}
        alertSeverity={alertSeverity} setAlertSeverity={setAlertSeverity}
        sendAlert={sendAlert} selectedCount={selected.size}
      />
      <MjScenarioEndDialog
        open={endOpen} onClose={() => setEndOpen(false)}
        characters={characters.filter((c) => !c._isInstance)} selected={selected}
        successLog={successLog} gaugesByCharId={gaugesByCharId} scenarioSnapshot={scenarioSnapshot}
        rewardsByCharId={rewardsByCharId}
        statOptions={STAT_OPTIONS} buildFieldLabel={buildFieldLabel}
        ensureRewardRows={ensureRewardRows} addRewardRow={addRewardRow}
        removeRewardRow={removeRewardRow} updateRewardRow={updateRewardRow}
        draconiqueInitByCharId={draconiqueInitByCharId} updateDraconiqueInit={updateDraconiqueInit}
        draconiqueByCharId={draconiqueByCharId}
        celesteByCharId={celesteByCharId}
        celesteInputByCharId={celesteInputByCharId} updateCelesteInput={updateCelesteInput}
        onConfirm={handleEndScenario}
      />

      <MjGaugeEditDialog
        dialog={mjEditDialog} onClose={() => setMjEditDialog(null)}
        delta={mjEditDelta} setDelta={setMjEditDelta} onConfirm={confirmMJEdit}
      />

      <MjMobGaugeSetupDialog
        open={mobGaugeSetupOpen} onClose={() => setMobGaugeSetupOpen(false)}
        mobGaugeSetup={mobGaugeSetup} setMobGaugeSetup={setMobGaugeSetup}
        mobKoGauge={mobKoGauge} setMobKoGauge={setMobKoGauge}
        mobDeathGauge={mobDeathGauge} setMobDeathGauge={setMobDeathGauge}
        onConfirmStart={() => { setMobGaugeSetupOpen(false); setCurrentTurnIdx(0); setCombatActive(true); }}
      />

      <MjConfirmInactiveDialog
        open={confirmInactiveOpen} onClose={() => setConfirmInactiveOpen(false)}
        confirmInactiveChars={confirmInactiveChars} characters={characters}
        combatInactives={combatInactives} setCombatInactives={setCombatInactives}
        mobKoGauge={mobKoGauge} mobDeathGauge={mobDeathGauge}
        setMobGaugeSetup={setMobGaugeSetup} setMobGaugeSetupOpen={setMobGaugeSetupOpen}
        setCombatActive={setCombatActive} setCurrentTurnIdx={setCurrentTurnIdx}
      />

    </div>
  );
}

export default ConnectGameMJ;
